<script setup>
import { debounce } from 'lodash';
import { computed, ref, watch, toValue, onMounted } from 'vue';
import api from './api';
import SearchResultSimpleListing from './components/SearchResultSimpleListing.vue';
import Icon from './components/Icon.vue';

const searchQuery = ref('');
const queryValue = computed((previous) => {
	if (searchQuery.value.length >= 3) return searchQuery.value;

	return previous;
});

const searchParams = ref({
	query: queryValue,
	perPage: 30,
	responseType: 'JsonObject',
	fields: '*',
	postFilters: {
		//
	},
	enableFacetFiltering: true
});
const { data, error, searching: isSearching } = api.search(searchParams);

let autoCompleteParams = ref({
	query: queryValue,
	results: 5
});

const { data: autocompleteData, error: autocompleteError } = api.autocomplete(autoCompleteParams);

const quicklinks = ref([]);

const fetchQuicklinks = async () => {
	let response = await api.quicklinks();

	quicklinks.value = response;
};

const topHit = computed(() => {
	let match = quicklinks.value.find((row) => row.term.toLowerCase() === queryValue.value);

	console.log({ match });

	return match;
});

const searchPageUrl = computed(() => {
	let searchParams = new URLSearchParams();

	searchParams.set('query', searchQuery.value);

	return `${WWW_ROOT}search?${searchParams.toString()}`;
});

onMounted(() => {
	fetchQuicklinks();
});

function onSuggestionClicked(item) {
	searchQuery.value = item;
}

function onSubmit(event) {
	//
}
</script>

<template>
	<div class="event_filter_search event_filter_search_desktop" id="site_search" role="search">
		<form class="event_filter_search_form" @submit.prevent="onSubmit">
			<label class="event_filter_search_label visually_hide" for="search_term_string_query"
				>Search</label
			>
			<div class="event_filter_search_input_wrap">
				<span class="event_filter_search_icon"><Icon slug="search" /></span>
				<input
					aria-live="polite"
					autocomplete="false"
					class="event_filter_search_input"
					type="search"
					placeholder="Search by name or tag"
					v-model="searchQuery"
				/>
				<button
					class="event_filter_search_button"
					type="submit"
					title="submit"
					aria-label="submit"
				>
					<span class="event_filter_search_button_label">Search</span>
					<span class="event_filter_search_button_icon"><Icon slug="search" /></span>
				</button>
			</div>
		</form>
	</div>

	<SearchResultSimpleListing
		:data="data"
		:top-hit="topHit"
		:is-searching="isSearching"
		:suggestions="autocompleteData"
		:search-page-url="searchPageUrl"
		@suggestion-clicked="onSuggestionClicked"
	/>
</template>
